// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"9eceae3c2e61b1d07e9c","883":"8f36a9701207c92f839f"}[chunkId] + ".js";
};